<!--
  @Description 基础设置
  @Date 2021-12-22
  @Author liushuo
-->
<template>
  <div class="container">
    <homeHeader title="基础设置"></homeHeader>
    <div class="main">
      <div class="card">
        <!-- 按钮组 -->
        <div class="toolbar-dv">
          <toolBarBtn
            @changeSearchFormShow="changeSearchFormShow"
            :buttonVisible="buttonVisible"
            :parentData="this"
            ref="toolBarBtn"
          ></toolBarBtn>
        </div>

        <!-- 基础设置功能区 -->
        <div class="settings-table-dv">
          <!-- 列表 -->
          <div
            class="left-settings-dv"
            :style="{ height: this.settingsCardHeight }"
          >
            <div class="settings-list-dv" :style="{ height: this.tableHeight }">
              <navList
                :listData="settingsList"
                title="基础设置名称"
                listKey="name"
                indexKey="name"
                :indexValue="indexValue"
                @itemClick="changeSelect"
              ></navList>
            </div>
          </div>
          <!-- 明细表格 -->
          <div
            class="right-user-dv"
            :style="{ height: this.settingsCardHeight }"
          >
            <div class="table-dv">
              <component
                :is="curSelectComponent"
                ref="componentForm"
              ></component>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      searchFormVisible: false,
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 默认加载的基础设置
      curSelectComponent: 'productVersion',
      // 选中菜单
      indexValue: '产品版本设置',
      // 按钮组的可见性
      buttonVisible: {
        update: false,
        add: false, // 新增按钮是否显示
        save: true, // 保存按钮是否显示
        delete: false,
        refresh: true,
        lock: false, // 锁定按钮是否显示
        unlock: false, // 解锁按钮是否显示
        sort: false, // 排序按钮是否显示
        search: false, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      // 左侧列表数据
      settingsList: [
        {
          name: '产品版本设置',
          componenetName: 'productVersion'
        },
        // {
        //   name: '单个菜单修改天数设置',
        //   componenetName: 'menuModifyDaySetting'
        // }
      ],
    }
  },
  mounted () {
    this.initRightForEdit()
  },
  methods: {
    // 根据权限，初始化控件是否显示
    initRightForEdit () {
      this.buttonVisible.save = this.isCanEdit
    },
    save () {
      this.$refs.componentForm.updateData()
    },
    refresh () {
      this.$refs.componentForm.BindText()
    },
    // 切换查询面板可见性
    changeSearchFormShow () {
      this.searchFormVisible = !this.searchFormVisible
    },
    // 切换
    changeSelect (item) {
      this.indexValue = item.name
      this.curSelectComponent = item.componenetName
    }
  },
  computed: {
    tableHeight () {
      let isSearchForm = this.searchFormVisible
      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      let isToolBar = true
      return this.tableHeightComputed(tableMargin + this.topBottomMargin, isSearchForm, isToolBar)
    },
    // 设置表格容器的高度
    settingsCardHeight () {
      return this.tableHeight + this.topBottomMargin
    },
    // 可编辑条件：岗位为 [管理]
    isCanEdit () {
      return ['运维', '管理'].includes(this.$store.state.userInfo.gangWei)
    }
  },
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.search-dv {
  background-color: aquamarine;
  height: 100px;
  margin: @main-margin 10px;
}

.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

.settings-table-dv {
  display: flex;
}
// 左侧名称列表
.left-settings-dv {
  width: 15%;
  padding: 10px;
}
.settings-list-dv {
  width: 100%;
  border-radius: 5px;
  box-shadow: #e2e2e2 0px 0px 3px;
  border: 1px solid #eeeeee;
  overflow: hidden;
  position: relative;
}

// 用户名列表
.right-user-dv {
  width: 85%;
}
</style>
